<app-navbar></app-navbar>

<!-- Banner Section HTML -->
<section class="banner-section" id="home">
  <div class="banner-container">
    <!-- Remove img tag, use background-image via style binding -->
    <div class="banner-image" [style.background-image]="'url(' + bannerImageUrl + ')'"></div>
    <div class="container">
      <div class="row">
        <div class="col-md-7 col-sm-12">
          <div class="banner-content">
            <h1 class="banner-title">Digital Alchemy</h1>
            <h2 class="banner-subtitle">La Solution Parfaite pour <span class="type-it-2">{{ displayedText }}</span></h2>
            <div class="banner-button">
              <a href="#contact" class="btn contact-btn">CONTACT NOUS</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

  <section class="white-bg pb-80" id="services">
    <div class="container">
        <div class="row">
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title">
                    <h2 class="raleway-font color1">Ce Que Nous Offrons</h2>
                    <h1 class="raleway-font">Nos Services</h1>
                </div>
                <h4>Un service de qualité pour la croissance de votre identité.</h4>
            </div>
        </div>

        <div class="row mt-50">
            <div *ngFor="let service of services" class="col-md-4 col-sm-4 col-xs-12 mb-30 feature-box text-center hover-effect">
                <div class="gradient-bg-icon-three mb-20" style="background: linear-gradient(to right, #202748, #4554a4);">
                    <i [ngClass]="service.icon"></i>
                </div>
                <h5 class="mt-10">{{service.title}}</h5>
                <p class="font-400">{{service.desc}}</p>
            </div>
        </div>
        <div class="row mt-20" id="about" >
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title">
                    <h2 class="raleway-font color1">À propos de DGITAL ALCHEMY</h2>
                    <h1 class="raleway-font">Présentation de l'entreprise</h1>
                </div>
                <p>Digital-Alchemy est une agence digitale dynamique basée à Rabat, au Maroc, spécialisée dans la photographie et la production vidéo, le design graphique, le développement de sites web, d'applications web et mobiles, la stratégie digitale et l'impression. Nous aidons les entreprises à transformer leur présence numérique avec des solutions innovantes qui stimulent la croissance, l'engagement et le succès. Laissez-nous transformer vos idées en or numérique.</p>
            </div>
        </div>
        <div class="row mt-20">
            <div class="col-md-6 col-sm-12">
                <div class="responsive-screen">
                    <img src="assets/images/Untitled-2.png" class="img-responsive border-radius-25" alt="about-heading-1" />
                </div>
            </div>
            <div class="col-md-6 col-sm-12 text-left d-flex align-items-center">
                <div class="d-block pl-30 sm-pl-0">
                    <div class="section-title mt-50">
                        <h2 class="raleway-font mt-0" style="color: #4554a4;">Nos Missions</h2>
                        <h1 class="raleway-font mt-30 font-50px font-300">Ce qui nous rend uniques</h1>
                    </div>
                    <p>Nous sublimons votre marque avec des visuels percutants, créons du contenu engageant et efficace, développons des sites web personnalisés pour une visibilité optimale, et produisons des vidéos marketing qui captivent et stimulent votre audience .</p>
                    
                    <p class="mt-30 mb-0"><a class="btn btn-lg btn-square" style="background: linear-gradient(to right, #202748, #4554a4); color: white;">Contact-Nous</a></p>
                </div>
            </div>
        </div>


    </div>
</section>



<section class="bordered-bg white-bg lg-section xs-pb-100 xs-pt-100">
    <div class="col-md-6 col-sm-6 bg-flex bg-flex-right">
        <div class="bg-flex-holder bg-flex-cover" style="background-image: url(assets/images/Untitled-3.jpg);"></div>
    </div>
    <div class="container">
        <div class="col-md-5 col-sm-6">
            <div class="section-title mb-50">
                <h2 class="raleway-font mt-0 font-20px color1">Notre Vision</h2>
                <h1 class="raleway-font mt-0 font-50px font-300">We Are Digital</h1>
            </div>
            <p>Nous imaginons un monde où chaque marque rayonne avec passion et créativité. Nous aspirons à insuffler de l'émotion dans chaque visuel, contenu, site web et vidéo, afin que chaque projet dépasse les attentes et touche profondément le cœur de votre audience.</p>
            <p class="mt-30 mb-0"><a class="btn btn-lg btn-square" style="background: linear-gradient(to right, #202748, #4554a4); color: white;">Contact-Nous</a></p>
        </div>
    </div>
</section>

<section class="white-bg lg-section xs-pt-100 xs-pb-100">
    <div class="col-md-6 col-sm-6 bg-flex bg-flex-left">
        <div class="bg-flex-holder bg-flex-cover" style="background-image: url(assets/images/Untitled-4.jpg);"></div>
    </div>
    <div class="container">
        <div class="col-md-5 col-sm-6 offset-md-7 offset-md-6">
            <div class="section-title mb-50">
                <h2 class="raleway-font mt-0 font-20px color1">Nos Objectifs</h2>
                <h1 class="raleway-font mt-0 font-50px font-300">We Are Partners</h1>
            </div>
            <p>Transformer votre présence digitale grâce à des visuels inspirants, un contenu percutant, des sites web sur mesure et des vidéos marketing captivantes, afin de maximiser votre impact, engager votre audience et propulser votre succès.</p>
            <p class="mt-30 mb-0"><a class="btn btn-lg btn-square" style="background: linear-gradient(to right, #202748, #4554a4); color: white;">Contact-Nous</a></p>
        </div>
    </div>
</section>

<section style="background: linear-gradient(to right, #202748, #4554a4);" class="pt-80 pb-80">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="section-title mb-50 white-color text-center">
                    <h1 class="raleway-font remove-margin font-50px font-300">Our Process</h1>
                </div>
            </div>
        </div>
        <div class="row our-process-style-02">
            <div *ngFor="let step of steps" class="col-md-3 col-sm-6 col-xs-12 line xs-mb-30 sm-mb-30">
                <div class="icon-wrap white-bg">
                    <div class="icon">
                        <i [ngClass]="step.icon" style="color: #4554a4;"></i>
                    </div>
                </div>
                <div class="text-center white-color">
                    <h4 class="font-500">{{step.title}}</h4>
                    <p class="mb-0">{{step.desc}}</p>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- guarantees.component.html -->
<section class="white-bg xs-pb-100 pt-80" id="guarantees">
    <div class="container">
      <!-- Title Section -->
      <div class="row text-center mb-50">
        <div class="col-md-12">
          <h2 class="font-700 mb-10 color1">GARANTIE 30/30/30</h2>
          <p class="font-400 mb-30">Chaque site web et application web que nous concevons est couvert par notre engagement 30/30/30 :</p>
        </div>
      </div>
      
      <!-- Guarantees Section -->
      <div class="row">
        <div class="col-md-4 col-sm-4 col-xs-12 mb-30">
          <div class="purple-bg text-center white-color">
            <div class="icon-container mb-20">
              <i class="icofont icofont-rocket-alt-1 font-40px"></i>
            </div>
            <h4 class="mt-0 font-600">Site web lancé en 30 jours ou moins</h4>
            <p class="font-400">Création et déploiement de votre site web professionnel, optimisé et responsive en moins de 30 jours garantis.</p>
          </div>
        </div>
        
        <div class="col-md-4 col-sm-4 col-xs-12 mb-30">
          <div class="purple-bg text-center white-color">
            <div class="icon-container mb-20">
              <i class="icofont icofont-headphone-alt font-40px"></i>
            </div>
            <h4 class="mt-0 font-600">30 jours de support technique</h4>
            <p class="font-400">Support technique gratuit après le lancement de votre site ou campagne pour assurer votre succès digital.</p>
          </div>
        </div>
        
        <div class="col-md-4 col-sm-4 col-xs-12 mb-30">
          <div class="purple-bg text-center white-color">
            <div class="icon-container mb-20">
              <i class="icofont icofont-laptop-alt font-40px"></i>
            </div>
            <h4 class="mt-0 font-600">30 minutes de formation gratuite</h4>
            <p class="font-400">Session de formation et consultation sur votre stratégie de marketing digital et présence sur les réseaux sociaux.</p>
          </div>
        </div>
      </div>
      
    </div>
  </section>

<section style="background: linear-gradient(to right, #202748, #4554a4);" class="xs-pb-60">
    <div class="col-md-6 col-sm-6 bg-flex bg-flex-left">
        <div class="bg-flex-holder bg-flex-cover" style="background-image: url(assets/images/Untitled-5.jpg);">
            <div class="video-box_overlay">
                <div class="center-layout">
                    <div class="v-align-middle"> 
                        <a (click)="openPopup()">
                            <div class="play-button"><i class="tr-icon ion-android-arrow-dropright"></i></div>
                        </a> 
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid">
        <div class="col-md-6 col-sm-6 offset-md-6 offset-md-6">
            <div class="col-inner spacer white-color text-center">
                <h2 class="raleway-font mt-0 font-20px xs-font-17px">Notre Histoire</h2>
                <h1 class="raleway-font mt-0 font-50px font-300 xs-font-27px">Découvrez Notre Univers</h1>
                <p>Nous allions créativité, stratégie et technologie pour transformer votre image en une marque forte et mémorable.<br>
                    De la conception graphique au développement web, en passant par le contenu social et la vidéo, nous façonnons votre présence digitale avec passion.</p>
                <p><a (click)="scrollToSection('contact')" class="btn btn-md btn-square btn-light-outline mt-30">Rencontrez l’Équipe</a></p>
            </div>
        </div>
    </div>
    
</section>

<!-- Video Popup -->
<div class="video-popup" *ngIf="isOpen">
    <div class="popup-inner">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/DaSzmOlbAO4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <button (click)="closePopup()" type="button" class="close-btn">
            <i class='icofont icofont-close'></i>
        </button>
    </div>
</div>

<div class="portfolio-modal" [class.active]="selectedPortfolio" *ngIf="selectedPortfolio">
  <div class="modal-backdrop" (click)="closePortfolioModal()"></div>
  <div class="modal-content">
    <button class="modal-close" (click)="closePortfolioModal()">×</button>
    <div class="modal-body">
      <div class="modal-content-wrapper">
        <!-- Left Side: Preview (WebP Image) -->
        <div class="modal-preview-left">
          <!-- Image Preview Container (WebP) -->
          <div class="image-preview-container">
            <img [src]="getWebpImageUrl(selectedPortfolio)" [alt]="selectedPortfolio.title" class="preview-image">
          </div>
        </div>

        <!-- Right Side: Description/Info -->
        <div class="modal-info-right">
          <div class="modal-header">
            <h3>{{ selectedPortfolio.title }}</h3>
          </div>
          <p class="modal-description">{{ selectedPortfolio.fullDescription || selectedPortfolio.description }}</p>
          <div class="modal-tech">
            <span *ngFor="let tech of selectedPortfolio.technologies" class="tech-tag">{{ tech }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<section id="portfolio" class="portfolio-showcase-section">
  <div class="container">
    
    <!-- Section Header -->
    <div class="portfolio-header">
      <h2>Découvrez Notre Galerie de Projets Exceptionnels</h2>
      <p class="portfolio-subtitle">
        Explorez nos réalisations et laissez-vous inspirer par notre savoir-faire. 
        Nous transformons les idées en expériences numériques innovantes et impactantes.
      </p>
    </div>
    
    <!-- Portfolio Filter Tabs -->
    <div class="portfolio-filters">
      <button 
        *ngFor="let filter of portfolioFilters" 
        [class.active]="activeFilter === filter.value"
        (click)="setActiveFilter(filter.value)"
        class="filter-btn">
        {{ filter.label }}
      </button>
    </div>
    
    <!-- Portfolio Grid -->
    <div class="portfolio-grid">
      <div 
        *ngFor="let item of getFilteredPortfolio(); let i = index" 
        class="portfolio-item"
        [style.animation-delay]="i * 0.1 + 's'"
        (click)="openPortfolioModal(item)">
        
        <div class="portfolio-card">
          <div class="portfolio-image-wrapper">
            <img [src]="item.image && item.image.startsWith('portfolio/') ? getPreviewImageUrl(item) : ('assets/images/' + item.image)" [alt]="item.title" class="portfolio-image">
            <div class="portfolio-overlay">
              <div class="portfolio-overlay-content">
                <h3 class="portfolio-title">{{ item.title }}</h3>
                <p class="portfolio-category">{{ item.category }}</p>
              </div>
            </div>
          </div>
          
          <!-- Portfolio Info -->
          <div class="portfolio-info">
            <h4 class="portfolio-name">{{ item.title }}</h4>
            <p class="portfolio-brief">{{ item.brief }}</p>
          
          </div>
        </div>
      </div>
    </div>
    
    <!-- Load More Button -->
    <div class="portfolio-cta" *ngIf="hasMoreProjects">
      <button class="load-more-btn" (click)="loadMoreProjects()">
        <span>Voir Plus de Projets</span>
        <div class="btn-arrow">↓</div>
      </button>
    </div>
    
  </div>
</section>

<section class="parallax-bg fixed-bg" style="background-image: url('assets/images/Untitled-5.jpg')">
    <div class="gradient-overlay-bg-two" style="background: linear-gradient(to right, rgba(32, 39, 72, 0.8), rgba(69, 84, 164, 0.8));"></div>
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center parallax-content height-400px">
                <div class="center-layout">
                    <div class="v-align-middle">
                        <h1 class="font-400 white-color raleway-font xs-font-40px">L'innovation numérique commence par une idée, grandit avec la créativité et réussit grâce à la technologie.</h1>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="grey-bg pt-120 pb-120">
    <div class="container">
        <div class="row">
            <div class="client-slider">
                <owl-carousel-o [options]="customOptionsFour" class="owl-btn-center-lr">
                    <ng-template carouselSlide *ngFor="let slide of slideStoreFour">
                        <div class="client-logo">
                            <img class="img-responsive" src="{{slide.image}}" alt="01" />
                        </div>
                    </ng-template>
                </owl-carousel-o>
            </div>
        </div>

    </div>
</div>

<section class="white-bg transition-none" id="contact">
    <div class="container">
        <div class="row">
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title">
                    <h2 class="raleway-font color1">Restez en contact</h2>
                    <h1 class="raleway-font">Contactez-nous maintenant</h1>
                </div>
                <p>Vous avez une question ou besoin d'assistance ? Notre équipe est là pour vous aider. N'hésitez pas à nous contacter pour toute demande d'information ou de support. Nous nous engageons à vous répondre dans les plus brefs délais.</p>
            </div>
        </div>
    </div>

    <div class="container">
        <div class="row mt-70">
            <div class="col-md-6 col-sm-6 col-xs-12 xs-mb-50">
                <div class="row mt-20">
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="section-title">
                            <h2 class="raleway-font color1">Adresse postale</h2>
                            <p class="mt-30">Bd Dammam, Technopark Casablanca , Maroc .
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="section-title">
                            <h2 class="raleway-font color1">Numéros de bureau</h2>
                            <p class="mb-0 mt-30">Mobile : +212 690 459 525</p>
                            <p class="mb-0">Mobile : +33 6 66 07 64 55</p>
                        </div>
                    </div>
                </div>
                <div class="row mt-20">
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="section-title">
                            <h2 class="raleway-font color1">Notre e-mail</h2>
                            <p class="mb-0 mt-30">Digitalalchemyma&#64;gmail.com</p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="section-title">
                            <h2 class="raleway-font color1">Support rapide</h2>
                            <p class="mb-0 mt-30">Otmane.zouitni&#64;gmail.com</p>
                        </div>
                    </div>
                </div>
                <div class="row mt-20">
                    <div class="col-md-12 social-icons-style-01">
                      <ul class="md-icon left-icon">
                        <li *ngFor="let social of socialMedia">
                          <a [ngClass]="social.iconClass" 
                             [href]="social.url" 
                             target="_blank" 
                             rel="noopener noreferrer"
                             style="background-color: #4554a4;">
                            <i [ngClass]="social.icon"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
            </div>
            <div class="col-md-6 col-sm-6 col-xs-12">
                <form (submit)="sendEmail($event)" class="contact-form" #contactForm="ngForm">
                  <div class="form-row">
                    <div class="form-column">
                      <div class="form-group">
                        <label class="form-label" for="user_name">Nom et Prénom</label>
                        <input type="text" minlength="2" maxlength="30"
                            [class.input-error]="userName.invalid && (userName.touched || formSubmitted)"
                            [class.input-success]="submissionSuccess && !isSubmitting"
                            name="user_name"
                            class="form-input" id="name" placeholder="Nom et Prénom *" 
                            [(ngModel)]="formData.user_name"
                            #userName="ngModel" required>
                        <div *ngIf="userName.invalid && (userName.touched || formSubmitted)" class="error-message">
                            Le nom et prénom sont requis.
                        </div>
                      </div>
                    </div>
                    <div class="form-column">
                      <div class="form-group">
                        <label class="form-label" for="user_email">Email</label>
                        <input type="email" minlength="2" maxlength="50"
                            [class.input-error]="userEmail.invalid && (userEmail.touched || formSubmitted)"
                            [class.input-success]="submissionSuccess && !isSubmitting"
                            name="user_email"
                            class="form-input" id="email" placeholder="Email *" 
                            [(ngModel)]="formData.user_email"
                            #userEmail="ngModel" required email>
                        <div *ngIf="userEmail.invalid && (userEmail.touched || formSubmitted)" class="error-message">
                            Une adresse email valide est requise.
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <!-- <div class="form-row">
                    <div class="form-column">
                      <div class="form-group">
                        <label class="form-label" for="enterprise">Entreprise</label>
                        <input type="text" maxlength="50" name="enterprise"
                            class="form-input" id="enterprise" placeholder="Entreprise" 
                            [(ngModel)]="formData.enterprise" #enterprise="ngModel">
                      </div>
                    </div>
                    <div class="form-column">
                      <div class="form-group">
                        <label class="form-label" for="telephone">Téléphone</label>
                        <input type="tel" maxlength="20" name="telephone"
                            class="form-input" id="telephone" placeholder="Téléphone" 
                            [(ngModel)]="formData.telephone" #telephone="ngModel">
                      </div>
                    </div>
                  </div> -->
                  
                  <div class="form-row">
                    <div class="form-column full-width">
                      <div class="form-group">
                        <label class="form-label" for="message">Détails du projet</label>
                        <textarea name="message" 
                            [class.input-error]="userMessage.invalid && (userMessage.touched || formSubmitted)"
                            [class.input-success]="submissionSuccess && !isSubmitting"
                            class="form-textarea" id="message" rows="7" placeholder="Détails du projet *"
                            [(ngModel)]="formData.message" #userMessage="ngModel" required></textarea>
                        <div *ngIf="userMessage.invalid && (userMessage.touched || formSubmitted)" class="error-message">
                            Les détails du projet sont requis.
                        </div>
                      </div>
                    </div>
                  </div>
              
                  <!-- Add a honeypot field to prevent spam -->
                  <div class="form-group" style="display:none">
                    <label for="botcheck">Bot Check</label>
                    <input type="text" name="botcheck" id="botcheck" class="form-control" value="">
                  </div>
              
                  <!-- Success message alert -->
                  <div *ngIf="submissionSuccess && !submissionError && !isSubmitting" class="success-alert">
                    <div class="success-icon">✓</div>
                    <div class="success-message">
                      Votre message a été envoyé avec succès!
                      <br>Nous vous répondrons dès que possible.
                    </div>
                  </div>
              
                  <!-- Error message alert -->
                  <div *ngIf="submissionError" class="error-alert">
                    <div class="error-icon">!</div>
                    <div class="error-message">{{ submissionError }}</div>
                  </div>
              
                  <div class="form-row">
                    <div class="form-column full-width">
                      <div class="button-container">
                        <button type="submit" name="submit"
                            class="submit-button"
                            [disabled]="isSubmitting" 
                            [class.button-loading]="isSubmitting">
                            <span *ngIf="!isSubmitting">ENVOYER LE MESSAGE</span>
                            <span *ngIf="isSubmitting" class="loading-spinner"></span>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
        </div>
    </div>
</section>


<footer class="footer-section">
    <div class="footer-container">
      
      <!-- Main Footer Content -->
      <div class="footer-content">
        
        <!-- Section 1: Company Logo & Description -->
        <div class="footer-company">
          <div class="company-logo">
            <img src="assets/images/logo-white.png" alt="Rhillane Logo" />
          </div>
          
          <p class="company-description">
            Digital Alchemy, votre partenaire de confiance pour la création de sites web . 
            Nous transformons vos idées en succès digital avec des solutions innovantes et performantes.
          </p>
          
          <!-- Social Media -->
          <div class="social-media-section">
            <ul style="display: flex; gap: 16px; list-style: none; padding: 0; margin: 0;">
              
              <!-- Facebook -->
              <li style="margin: 0;">
                <a href="https://www.facebook.com/people/Digital-alchemy/61565618420833" 
                   target="_blank" 
                   rel="noopener noreferrer"
                   title="Visit our Facebook page"
                   style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                  <svg style="width: 20px; height: 20px; color: #1877F2; fill: #1877F2;" viewBox="0 0 24 24">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                </a>
              </li>
              
              <!-- Behance -->
              <li style="margin: 0;">
                <a href="https://www.behance.net/digitalalchemy2" 
                   target="_blank" 
                   rel="noopener noreferrer"
                   title="Visit our Behance page"
                   style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                  <svg style="width: 20px; height: 20px; color: #1769FF; fill: #1769FF;" viewBox="0 0 24 24">
                    <path d="M0 4.4804V19.243h7.1554c.6613 0 1.3078-.0832 1.9297-.248.6288-.1654 1.1905-.4203 1.6792-.7661.485-.3431.8784-.7804 1.1677-1.3081.2862-.5258.4294-1.1471.4294-1.8641 0-.8784-.2067-1.6309-.6172-2.2506-.4073-.6172-.9897-1.0907-1.7494-1.4161.6388-.3431 1.1139-.8141 1.4285-1.4143.3146-.6002.4719-1.2755.4719-2.0274 0-.7193-.1327-1.3487-.4-1.8888-.2668-.5402-.6343-1.0033-1.0995-1.3914-.4652-.3881-.9712-.6884-1.5186-.8999C8.8135 4.5932 8.2071 4.4804 7.5446 4.4804H0zM15.3486 6.9795h4.7992v1.2755h-4.7992V6.9795zM3.2695 6.9795h3.8893c.9451 0 1.6612.2262 2.1463.6787.4851.4525.7277 1.0632.7277 1.8321 0 .8374-.2768 1.4676-.8323 1.8888-.5555.4212-1.2925.6323-2.2091.6323H3.2695V6.9795zM15.3486 13.2363h4.7992v1.2755h-4.7992v-1.2755zM3.2695 14.2834h4.3172c.6927 0 1.2944.1327 1.8051.3976.5107.2649.9378.6154 1.2755 1.0519.3377.4365.5849.9378.741 1.5044.1561.5666.2342 1.1543.2342 1.7632 0 .7193-.1014 1.3487-.3043 1.8888-.2029.5401-.5107.9949-.9237 1.3648-.4131.3699-.9378.6507-1.5743.8409-.6365.1902-1.3858.2853-2.2477.2853H3.2695v-7.0969z"/>
                  </svg>
                </a>
              </li>
              
              <!-- LinkedIn -->
              <li style="margin: 0;">
                <a href="https://www.linkedin.com/company/digital-alchemy-ma/" 
                   target="_blank" 
                   rel="noopener noreferrer"
                   title="Visit our LinkedIn page"
                   style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                  <svg style="width: 20px; height: 20px; color: #0077B5; fill: #0077B5;" viewBox="0 0 24 24">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                  </svg>
                </a>
              </li>
              
              <!-- YouTube -->
              <li style="margin: 0;">
                <a href="https://www.youtube.com/@Digital_Alchemy_ma" 
                   target="_blank" 
                   rel="noopener noreferrer"
                   title="Visit our YouTube page"
                   style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                  <svg style="width: 20px; height: 20px; color: #FF0000; fill: #FF0000;" viewBox="0 0 24 24">
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                  </svg>
                </a>
              </li>
              
              <!-- Instagram -->
              <li style="margin: 0;">
                <a href="https://www.instagram.com/digital_alchemy_ma/" 
                   target="_blank" 
                   rel="noopener noreferrer"
                   title="Visit our Instagram page"
                   style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                  <svg style="width: 20px; height: 20px; color: #E1306C; fill: #E1306C;" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                </a>
              </li>
              
            </ul>
          </div>
        </div>
        
        <!-- Section 2: Contact Information -->
        <div class="footer-contact">
          <h3 class="footer-title">CONTACT</h3>
          
          <div class="contact-info">
            <div class="contact-item">
              <span>+212 690 459 525</span>
            </div>
            <div class="contact-item">
              <span>+33 6 66 07 64 55</span>
            </div>
            <div class="contact-item">
              <span>Digitalalchemyma&#64;gmail.com</span>
            </div>
            <div class="contact-item">
              <span>Contact&#64;digalchemy.com</span>
            </div>
          </div>
          
          <div class="office-locations">
            <div class="office-item">
              <h4>NOTRE BUREAU AU MAROC</h4>
              <p>Bd Dammam, Technopark Casablanca , Maroc .</p>
            </div>
          </div>
        </div>
        
        <!-- Section 3: Services Column -->
        <div class="footer-links">
          <h3 class="footer-title">NOS SERVICES</h3>
          <ul class="footer-list">
            <li><a routerLink="/web">Sites Web</a></li>
<li><a routerLink="/appweb">Application Web</a></li>
            <li><a routerLink="/publicite">Publicité en ligne</a></li>
            <li><a routerLink="/gestion">Gestion des réseaux sociaux</a></li>
            <li><a routerLink="/design">Design Graphique</a></li>
            <li><a routerLink="/agence">Agence SEO</a></li>
          </ul>
        </div>
        
        <!-- Section 4: Quick Links Column -->
        <div class="footer-links">
          <h3 class="footer-title">LIENS RAPIDES</h3>
          <ul class="footer-list">
            <li><a routerLink="/">Accueil</a></li>
            <li><a routerLink="/apropos">À propos</a></li>
            <li><a routerLink="/contact">Contact</a></li>
            <li><a routerLink="/cgu">Conditions Générales d'Utilisation</a></li>
            <li><a routerLink="/conf">Politique de Confidentialité</a></li>
          </ul>
        </div>
        
      </div>
      
      <!-- Footer Bottom -->
      <div class="footer-bottom">
        <div class="footer-bottom-content">
          <p class="copyright">
            © {{ currentYear }} Digital Alchemy. Tous droits réservés. | 
            <a routerLink="/cgu">Mentions légales</a> | 
            <a routerLink="/conf">Politique des cookies</a>
          </p>
          <div class="footer-bottom-links">
            <a routerLink="/contact">Support</a>
          </div>
        </div>
      </div>
      
    </div>
  </footer>
